import { forwardRef } from "react";
import "../auth-styles.css";
import { clsx } from "../util";
import styles from "./SocialButton.module.css";
// PRIVATE API
export const SocialButton = forwardRef(({ children, className, ...props }, ref) => (<a className={clsx(styles.socialButton, className)} {...props} ref={ref}>
    {children}
  </a>));
//# sourceMappingURL=SocialButton.jsx.map